module.exports = {"phase":{"D":["Basement","0","1","2","3","4","5","6","7","8","9","Roof"],"E":["Basement","0","1","2","3","Roof"],"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/fulhamReach.json
// module id = 115
// module chunks = 0